import React from 'react';

const SignatureAccount = ({ imageURL, cuenta, title = 'Firma de conformidad', imgLabel = 'Firma generada' }) => {
    return (
        <div className="row">
            <div className="col-xl-12 resumen-entrega-subtitulo pt-4">{title}</div>
            <div className="col-xl-12 resumen-entrega-firma">
                <>
                    {imageURL ? (
                        <img
                            src={imageURL}
                            alt={imgLabel}
                            style={{
                                display: 'block',
                                margin: '0 auto',
                                width: '200px',
                                height: '125px',
                            }}
                        />
                    ) : null}
                </>
            </div>
            <p className="resumen-entrega-firmante">{cuenta?.productor_nombre}</p>
            <br />
        </div>
    );
};

export default SignatureAccount;